const ENV = {
    GOOGLE_ANALYTICS_MEASUREMENT_ID: process.env.REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID,
    API_URL: process.env.REACT_APP_API_URL,
    // Authorize.Net Accept.js (both values are public by design; the transaction key stays on the server)
    AUTHNET_LOGIN_ID: process.env.REACT_APP_AUTHNET_LOGIN_ID,
    AUTHNET_CLIENT_KEY: process.env.REACT_APP_AUTHNET_CLIENT_KEY
}

export default ENV;